import React, { useState } from "react";

import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../components/common/back-arrow";
const CHANGE_PASSWORD = gql`
  mutation UpdateUserPassword($oldPassword: String!, $newPassword: String!) {
    updateUserPassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      ok
      error
    }
  }
`;
const ChangePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted: (data) => {
      if (data.updateUserPassword.ok) {
        navigate("/");
      }
    },
    // TODO: 아폴로 에러라는 글씨 빼야하는데
    onError: (error) => alert(error),
  });

  const onClickButton = async () => {
    await changePassword({
      variables: {
        oldPassword,
        newPassword,
      },
    });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#fff] p-4">
      <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-md">
        <div onClick={() => navigate(-1)}>
          <BackArrow />
        </div>
        {/* Header */}
        <h2 className="text-2xl font-semibold text-center text-black mb-6">
          비밀번호 재설정
        </h2>

        {/* Password Reset Form */}
        <div className="space-y-4">
          <div>
            <label
              htmlFor="oldPassword"
              className="block text-sm font-medium text-black mb-2"
            >
              기존 비밀번호
            </label>
            <input
              type="password"
              id="oldPassword"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#1562fc]"
              placeholder="기존 비밀번호를 입력하세요."
            />
          </div>

          <div>
            <label
              htmlFor="newPassword"
              className="block text-sm font-medium text-black mb-2"
            >
              비밀번호 재설정
            </label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#1562fc]"
              placeholder="새로운 비밀번호를 입력하세요."
            />
          </div>

          <div>
            <label
              htmlFor="passwordConfirm"
              className="block text-sm font-medium text-black mb-2"
            >
              비밀번호 재설정 확인
            </label>
            <input
              type="password"
              id="passwordConfirm"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#1562fc]"
              placeholder="비밀번호를 다시 입력하세요."
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full py-3 rounded-md text-white font-semibold ${"bg-[#1562fc] hover:bg-[#124ab7] transition duration-150"}`}
            onClick={async () => await onClickButton()}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
